import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { LEGAL_DOCS } from '../data/legalContent';

export default function LegalPage({ docKey }) {
  const params = useParams();
  const key = docKey || params.docKey;
  const doc = LEGAL_DOCS[key];

  useEffect(() => { window.scrollTo(0, 0); }, [key]);

  if (!doc) {
    return (
      <div className="min-h-screen pt-32 pb-20 px-6 text-center">
        <p className="text-white/40 font-manrope">Document not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-32 pb-24 px-6" data-testid={`legal-page-${key}`}>
      <div className="max-w-3xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <Link to="/" className="inline-flex items-center gap-2 text-white/30 hover:text-[#D4AF37] font-manrope text-xs uppercase tracking-widest mb-10 transition-colors" data-testid="legal-back-link">
            <ArrowLeft size={14} /> Back to Home
          </Link>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-manrope font-semibold mb-3">Legal</p>
          <h1 className="font-playfair text-3xl sm:text-4xl text-white mb-2">{doc.title}</h1>
          <p className="text-[#D4AF37]/60 font-manrope text-xs uppercase tracking-widest mb-8">{doc.effective}</p>
          <p className="text-white/50 font-manrope text-sm leading-relaxed mb-12">{doc.intro}</p>

          <div className="space-y-10" data-testid="legal-content">
            {doc.sections.map((section, i) => (
              <div key={i}>
                <h2 className="font-playfair text-lg text-white mb-3">{section.heading}</h2>
                {(section.body || []).map((p, j) => (
                  <p key={j} className="text-white/40 font-manrope text-sm leading-relaxed mb-2">{p}</p>
                ))}
                {section.bullets && (
                  <ul className="space-y-2 mt-2">
                    {section.bullets.map((b, j) => (
                      <li key={j} className="text-white/40 font-manrope text-sm leading-relaxed pl-5 relative">
                        <span className="absolute left-0 text-[#D4AF37]">•</span>{b}
                      </li>
                    ))}
                  </ul>
                )}
                {section.after && (
                  <p className="text-white/40 font-manrope text-sm leading-relaxed mt-3">{section.after}</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-white/5">
            <p className="text-white/20 font-manrope text-xs">
              &copy; {new Date().getFullYear()} Dream Room Theaters. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
